// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '15c3bbf37f6d1fd478c17e72ce7061c5bb28facc';
export const BUILD_NUMBER = '273';
export const BUILD_TIMESTAMP = '2026-10-21T07:54:54.766Z';
